import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { PropsWithChildren, useEffect } from "react";

type ProductAccordionWithMonetateEventsProps = {
  children: React.ReactNode;
  name: string;
  open?: boolean;
};
export function ProductAccordionWithMonetateEvents({
  name,
  children,
  open,
}: PropsWithChildren<ProductAccordionWithMonetateEventsProps>) {
  useEffect(() => {
    dispatchMonetateQEvent(`WPDP | Accordion Displayed | ${name}`);
  }, []);

  useEffect(() => {
    if (open) {
      dispatchMonetateQEvent(`WPDP | Accordion Opened | ${name}`);
    }
  }, [open]);
  return <>{children}</>;
}
